import React from 'react'
import { Box } from '@chakra-ui/react'
import { Icon } from '@chakra-ui/icons'
import ChatClientDetailsPhones from './phones'
import { ChatFieldsFragment } from '~graphql/generated/graphql'
import SharedDrawer from '~components/shared/modals/shared-drawer'
import ChatClientDetailsUpcomingReminders from './upcoming-reminders'
import ChatClientDetailsNextAppointment from './appointments/next-appointment'
import ChatClientDetailsLastAppointment from './appointments/previous-appointment'
import ChatClientDetails from './client-details'
import SharedStack from '~components/shared/wrappers/shared-stack'
import IconButtonWithTooltip from '~components/shared/icon-button-with-tooltip'
import { FaAngleDoubleRight, FaExpand } from 'react-icons/fa'
import { FaXmark } from 'react-icons/fa6'
import { navigate } from 'gatsby'

interface Props {
    isOpen: boolean
    onClose: () => void
    chat: ChatFieldsFragment
}

export default function ChatClientInfoDrawer({ isOpen, onClose, chat }: Props) {
    return (
        <SharedDrawer
            title="Client Info"
            size="xl"
            headerRightAction={
                <SharedStack row fit>
                    <IconButtonWithTooltip
                        icon={<Icon as={FaExpand} fontSize="sm" />}
                        label="View Full Details"
                        onClick={() => navigate('?client=' + chat.client.id)}
                        variant="outline"
                        size="xs"
                        h="28px"
                        w="28px"
                        rounded="full"
                    />
                    <IconButtonWithTooltip
                        icon={<Icon as={FaXmark} fontSize="sm" />}
                        label="Hide Client Info"
                        onClick={onClose}
                        variant="outline"
                        size="xs"
                        h="28px"
                        w="28px"
                        rounded="full"
                    />
                </SharedStack>
            }
            isOpen={isOpen}
            onClose={onClose}
            bodyOverrides={{
                p: 0,
            }}
        >
            <ChatClientDetails chat={chat} />
            <Box borderTopWidth={1} borderColor="gray.100">
                <ChatClientDetailsPhones chat={chat} />
                <ChatClientDetailsUpcomingReminders chat={chat} />
                <ChatClientDetailsNextAppointment chat={chat} />
                <ChatClientDetailsLastAppointment chat={chat} />
            </Box>
        </SharedDrawer>
    )
}
